export const DASHBOARD_API = process.env.REACT_APP_DASHBOARD_API || '';
export const RECTORAL_API = process.env.REACT_APP_RECTORAL_API || '';
